import React, { FunctionComponent } from 'react';

interface ITemplates {}

const Templates: FunctionComponent<ITemplates> = () => {
  return <></>;
};

export default Templates;
